import React, { lazy } from 'react';
import { Routes } from 'react-router-dom';
import { Route } from 'react-router-dom';

const Product = lazy(() => import('../../container/ecommerce/product/Products'));
const ProductAdd = lazy(() => import('../../container/ecommerce/product/AddProduct'));
const ProductEdit = lazy(() => import('../../container/ecommerce/product/EditProduct'));
const ProductDetails = lazy(() => import('../../container/ecommerce/product/ProductDetails'));
const Invoice = lazy(() => import('../../container/ecommerce/Invoice'));
const Orders = lazy(() => import('../../container/ecommerce/Orders'));
const OrderDetails = lazy(() => import('../../container/ecommerce/order/OrderDetails'));
const EditOrder = lazy(() => import('../../container/ecommerce/order/EditOrder'));
// const Sellers = lazy(() => import('../../container/ecommerce/Sellers'));
// const Cart = lazy(() => import('../../container/ecommerce/Cart'));

const EcommerceRoute = () => {
  return (
    <Routes>
      <Route path="products" element={<Product />} />
      <Route exact path="add-product" element={<ProductAdd />} />
      <Route exact path="edit-product" element={<ProductEdit />} />
      <Route exact path="productDetails/:id" element={<ProductDetails />} />
      <Route exact path="invoice" element={<Invoice />} />
      <Route exact path="orders/list" element={<Orders />} />
      <Route exact path="orders/show/:orderId" element={<OrderDetails />} />
      <Route path="orders/edit/:orderId" element={<EditOrder />} />
      {/* <Route exact path={`${path}/sellers`} component={Sellers} />
      <Route path={`${path}/cart`} component={Cart} /> */}
    </Routes>
  );
};

export default EcommerceRoute;
